import { render, staticRenderFns } from "./contactPerson.vue?vue&type=template&id=74873bb6&scoped=true&"
import script from "./contactPerson.vue?vue&type=script&lang=js&"
export * from "./contactPerson.vue?vue&type=script&lang=js&"
import style0 from "./contactPerson.vue?vue&type=style&index=0&id=74873bb6&lang=scss&scoped=true&"
import style1 from "./contactPerson.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74873bb6",
  null
  
)

export default component.exports